<!-- @format -->

<template>
  <FlexCol gap-3 class="border-gray-200 divide-y">
    <!-- Cabeçalho -->
    <Flex justify-between items-center gap-3>
      <Flex center>
        <span> Código: </span>
        <h2 class="font-bold px-3">{{ acquisition.id ?? 'Não Informado' }}</h2>
      </Flex>
      <FlexCol>
        <span> Data Lançamento: </span>
        <h2 class="font-bold">{{ formatDate(acquisition.acquisitionDate) ?? 'Não Informado' }}</h2>
      </FlexCol>
    </Flex>

    <!-- Identificadores -->
    <Flex justify-between items-center gap-3 class="py-3">
      <FlexCol>
        <span>Fornecedor</span>
        <h3 class="font-bold">{{ acquisition.supplierName ?? 'Não Informado' }}</h3>
      </FlexCol>
      <FlexCol>
        <span>Documento</span>
        <h3 class="font-bold">{{ acquisition.ntm ?? 'Não Informado' }}</h3>
      </FlexCol>
      <FlexCol>
        <span>Data Documento</span>
        <h3 class="font-bold">{{ formatDate(acquisition.nfeDate) ?? 'Não Informado' }}</h3>
      </FlexCol>
    </Flex>

    <!-- Status Recebimento -->
    <Flex justify-between items-center gap-3 class="py-3">
      <FlexCol>
        <span>Recebimento</span>
        <div class="py-2">
          <span class="py-1 px-2 border rounded-xl text-xs font-bold" :class="[item.status == 1 ? 'bg-green-400 text-green-800' : 'border-yellow-200 bg-yellow-200']">
            {{ acquisition.status === 1 ? 'Aprovado' : 'Pendente' }}
          </span>
        </div>
      </FlexCol>
      <FlexCol>
        <span>Recebido Por</span>
        <h3 :class="[acquisition.approverName ?? 'text-gray-400 font-bold italic']" class="font-bold">{{ acquisition.approverName ?? 'Pendente' }}</h3>
      </FlexCol>
      <FlexCol>
        <span>Data Recebimento</span>
        <h3 :class="[acquisition.updatedAt ?? 'text-gray-400 font-bold italic']" class="font-bold">
          {{ acquisition.status === 1 ? formatDate(acquisition.updatedAt) : 'Pendente' }}
        </h3>
      </FlexCol>
    </Flex>
    <!-- Tabela -->
    <Accordion title="Materiais">
      <TableFull :headers :items="item.items" v-model="tableControl" disableOrder ultradense>
        <template v-slot:price="{ item }">
          <span>{{ formatMoneyS(item.price * item.quantity) }}</span>
        </template>
        <template #footer v-if="acquisition.items && acquisition.items.length > 0">
          <td colspan="2"></td>
          <td class="px-5 py-1 font-semibold">Total:</td>
          <td class="px-5 py-1 font-semibold">
            {{ formatMoneyS(totalItems) }}
          </td>
        </template>
      </TableFull>
      <Flex v-if="acquisition.status === 0 && acquisition.items.length > 0" justifyEnd class="my-5">
        <Button id="addResourceBtn" label="Confirmar Recebimento" primary icon="fa-solid fa-circle-plus" @click="modalConfirm = true" />
      </Flex>
    </Accordion>

    <!-- Modal Confirmar Recebimento -->
    <Modal v-model="modalConfirm" size="w-6/12" :overflowVisible="calendarOpen">
      <FlexCol gap2>
        <Title class="text-primary-600 text-3xl font-bold" title="Confirmar Recebimento de Materiais" />
        <span>Ao confirmar, você concorda que todos os itens presentes no documento fiscal deste Aquisição de Materiais foram recebidos e conferidos.</span>
        <Grid cols2 gap10>
          <InputDateTime
            required
            v-model="acquisition.date"
            label="Data do Recebimento"
            :error="errors.date"
            class="col-span-1"
            @calendar-toggle="calendarOpen = $event"
            disabled />
          <InputZoom
            label="Responsável"
            v-model="acquisition.idUserApprover"
            v-model:completeObject="selectedUser"
            :error="errors.idUserApprover"
            database="user"
            item-text="name"
            item-value="id"
            required
            clearable
            class="col-span-1" />
        </Grid>
        <Flex justifyEnd class="mt-3">
          <Button id="addResourceBtn" label="Confirmar" primary icon="fa-solid fa-floppy-disk" @click="save" />
        </Flex>
      </FlexCol>
    </Modal>
  </FlexCol>
</template>

<script setup>
import { computed, onMounted, reactive, ref, watch } from 'vue'
import { useFormat } from '@/composables/useFormat'
import { useStore } from 'vuex'
import { update, get } from '@/crud'
import moment from 'moment'

const store = useStore()
const { formatDate, formatDatetimeToTimezone, formatMoneyS } = useFormat()

const item = defineModel('item', { type: Object })
const acquisition = ref([])
const modalForm = ref({})

const api = 'movement'
const headers = [
  { title: 'Código', field: 'code', disableOrder: true },
  { title: 'Item', field: 'name', disableOrder: true, itemClass: '!text-wrap' },
  { title: 'Quantidade', disableOrder: true, field: 'quantity', disableOrder: true },
  { title: 'Total', field: 'price', disableOrder: true },
]
const tableControl = ref({
  page: 1,
  total: item.value.items?.length,
  limit: item.value.items?.length,
  pages: 0,
  order: 'asc',
})
const errors = ref({})
const modalConfirm = ref(false)
const calendarOpen = ref(false)
const selectedUser = ref(null)

const getDynamicErrorMessage = (data, fallback = 'Erro ao confirmar recebimento') => {
  if (typeof data === 'string') return data
  if (data && typeof data === 'object') return Object.values(data)[0] || fallback
  return fallback
}

const user = computed(() => store.state.user)

const totalItems = computed(() => {
  let total = 0
  let listItems = item.value?.items ?? []
  if (listItems && listItems.length > 0) {
    listItems.forEach((item) => {
      if (item.price && item.quantity) {
        total += item.quantity * item.price
      }
    })
  }
  return total
})

const save = async () => {
  let response
  acquisition.value.status = 1
  if (selectedUser.value && selectedUser.value.name) {
    acquisition.value.approverName = selectedUser.value.name
  }

  response = await update(api, item.value.id, acquisition.value, 'movimentação')
  if (!response.error) {
    acquisition.value.type = 'entry'
    response = await update(api, item.value.id, acquisition.value, 'movimentação')
  }

  if (response.error) {
    store.dispatch('setError', {
      message: getDynamicErrorMessage(response.data),
    })
    acquisition.value.status = 0
    acquisition.value.type = 'acquisition'
    errors.value = response.data || {}
    return
  }

  store.dispatch('setSuccess', {
    message: 'Recebimento Confirmado',
  })
  try {
    const updateBadge = await get('menu/badges')
    store.dispatch('setBadges', updateBadge)
  } catch (err) {
    console.error('Error refreshing badges:', err)
  }
  modalConfirm.value = false
}
watch(
  () => item.value,
  (newVal) => {
    acquisition.value = newVal || {}
  },
  { immediate: true, deep: true },
)
watch(
  () => modalConfirm.value,
  (newVal) => {
    if (newVal) {
      acquisition.value.acquisitionDate = acquisition.value.acquisitionDate ? moment(acquisition.value.acquisitionDate).format() : null
      acquisition.value.date = moment().format()
      acquisition.value.nfeDate = acquisition.value.nfeDate ? moment(acquisition.value.nfeDate).format() : null
      acquisition.value.idUserApprover = user.value.id
    } else {
      calendarOpen.value = false
    }
  },
)
</script>
